export async function settledWithin<T>(
  read: Promise<T>,
  ms: number,
): Promise<T | "late" | "failed"> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  const late = new Promise<"late">((resolve) => {
    timer = setTimeout(() => resolve("late"), Math.max(0, ms));
  });
  try {
    return await Promise.race([read.catch((): "failed" => "failed"), late]);
  } finally {
    clearTimeout(timer);
  }
}
